// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__DqsvG","twitter":"styles_twitter__P5tyD","pintrest":"styles_pintrest__boZAJ"};